// extracted by mini-css-extract-plugin
export default {"item":"VideoItem_item__Kj8Nu","btn":"VideoItem_btn__oKMPM","close-btn":"VideoItem_close-btn__ViBWr","add-btn":"VideoItem_add-btn__UGD4f"};